"use client";

import { c as _c } from "react/compiler-runtime";
import { CustomImage } from "@repo/design-system/components/ui/custom-image";
import { CustomLink } from "@repo/design-system/components/ui/custom-link";
import { cn } from "@repo/design-system/utils/cn";
import ArrowRight from "~/components/icons/arrow-right-eon";
import Home from "~/components/icons/home-eon";
import Kununu from "~/components/icons/kununu-eon";
import useUCConsent from "~/hooks/use-uc-consent";
import { useLanguage } from "~/translations/loader/use-language";
import type { JobadComponentProps } from "~/types/job";
import YouTubePlayer from "../jobadvideo/youtube-eon";
import ExperienceReportsIntro from "./experience-reports-intro-eon";
export default function ExperienceReports(t0) {
  const $ = _c(82);
  const {
    job
  } = t0;
  const t = useLanguage();
  const {
    consentStatus
  } = useUCConsent("Kununu");
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[0] !== consentStatus || $[1] !== job.content.experienceReport || $[2] !== job.data.idClient || $[3] !== job.data.locations || $[4] !== t) {
    t7 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const locations = job.data.locations?.map(_temp);
      const data = job.content.experienceReport;
      let t8;
      if ($[12] !== data) {
        t8 = data?.type === "video" && new URL(data.link).searchParams.get("v");
        $[12] = data;
        $[13] = t8;
      } else {
        t8 = $[13];
      }
      const videoId = t8;
      if (!data) {
        t7 = null;
        break bb0;
      }
      const validIds = ["230421", "232072", "232073", "232074", "232075", "232076", "232078", "232079", "232081", "232083"];
      const isIntGraduate = validIds.includes(job.data.idClient);
      if (isIntGraduate) {
        let t9;
        if ($[14] !== t.intGraduate_exp_text || $[15] !== t.intGraduate_exp_title) {
          t9 = <ExperienceReportsIntro headline={t.intGraduate_exp_title} text={t.intGraduate_exp_text} />;
          $[14] = t.intGraduate_exp_text;
          $[15] = t.intGraduate_exp_title;
          $[16] = t9;
        } else {
          t9 = $[16];
        }
        let t10;
        if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
          t10 = <div className={cn("mx-auto mb-8 grid h-full max-w-screen-xl md:grid-cols-3 md:gap-8 xl:mb-12 xl:gap-12")}><div className={cn("relative col-span-2 h-full")}><YouTubePlayer thumbnailSrc="https://img.youtube.com/vi/j7CPmLEDgQs/maxresdefault.jpg" videoId="j7CPmLEDgQs" /></div><div className={cn("flex h-full flex-col justify-end")} /></div>;
          $[17] = t10;
        } else {
          t10 = $[17];
        }
        let t11;
        if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
          t11 = <Kununu className="size-12 text-primary" />;
          $[18] = t11;
        } else {
          t11 = $[18];
        }
        let t12;
        if ($[19] !== t.jobad_exp_card1_title) {
          t12 = <h3 className="mt-4 mb-5 font-bold text-4xl text-primary">{t.jobad_exp_card1_title}</h3>;
          $[19] = t.jobad_exp_card1_title;
          $[20] = t12;
        } else {
          t12 = $[20];
        }
        let t13;
        if ($[21] !== t.jobad_exp_card1_body) {
          t13 = <p className="text-foreground text-lg">{t.jobad_exp_card1_body}</p>;
          $[21] = t.jobad_exp_card1_body;
          $[22] = t13;
        } else {
          t13 = $[22];
        }
        let t14;
        if ($[23] !== consentStatus || $[24] !== t.jobad_exp_kununu_linkTitle) {
          t14 = consentStatus && <CustomLink aria-label={t.jobad_exp_kununu_linkTitle} blank={true} className="block pt-5" href="https://www.kununu.com/de/eon?utm_source=widget&utm_campaign=widget_selfservice_scoreandreview" title={t.jobad_exp_kununu_linkTitle}><CustomImage alt="Kununu widget" height={100} src="https://widgets.kununu.com/widget_score_review_count_logo_small/profiles/7b090ecc-a582-4eae-a1cb-0021748941ef" width={170} /></CustomLink>;
          $[23] = consentStatus;
          $[24] = t.jobad_exp_kununu_linkTitle;
          $[25] = t14;
        } else {
          t14 = $[25];
        }
        let t15;
        if ($[26] !== t12 || $[27] !== t13 || $[28] !== t14) {
          t15 = <div className="bg-card p-8 lg:p-12">{t11}{t12}{t13}{t14}</div>;
          $[26] = t12;
          $[27] = t13;
          $[28] = t14;
          $[29] = t15;
        } else {
          t15 = $[29];
        }
        let t16;
        if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
          t16 = <Home className="size-12 text-primary" />;
          $[30] = t16;
        } else {
          t16 = $[30];
        }
        let t17;
        if ($[31] !== t.jobad_exp_card2_title) {
          t17 = <h3 className="mt-4 mb-5 font-bold text-4xl text-primary">{t.jobad_exp_card2_title}</h3>;
          $[31] = t.jobad_exp_card2_title;
          $[32] = t17;
        } else {
          t17 = $[32];
        }
        let t18;
        if ($[33] !== t.jobad_exp_card2_body) {
          t18 = <p className="text-foreground text-lg">{t.jobad_exp_card2_body}</p>;
          $[33] = t.jobad_exp_card2_body;
          $[34] = t18;
        } else {
          t18 = $[34];
        }
        let t19;
        if ($[35] !== t17 || $[36] !== t18) {
          t19 = <div className="bg-card p-8 lg:p-12">{t16}{t17}{t18}</div>;
          $[35] = t17;
          $[36] = t18;
          $[37] = t19;
        } else {
          t19 = $[37];
        }
        let t20;
        if ($[38] !== t15 || $[39] !== t19) {
          t20 = <div className="px-6 md:px-10">{t10}<div className="mx-auto grid max-w-screen-xl gap-y-5 md:grid-cols-2 md:gap-8 xl:gap-12">{t15}{t19}</div></div>;
          $[38] = t15;
          $[39] = t19;
          $[40] = t20;
        } else {
          t20 = $[40];
        }
        let t21;
        if ($[41] !== t20 || $[42] !== t9) {
          t21 = <section className="py-16 print:hidden" id="experienceReports"><div className="inner-container">{t9}{t20}</div></section>;
          $[41] = t20;
          $[42] = t9;
          $[43] = t21;
        } else {
          t21 = $[43];
        }
        t7 = t21;
        break bb0;
      }
      t5 = "py-16 print:hidden";
      t6 = "experienceReports";
      t3 = "inner-container";
      if ($[44] !== t.jobad_exp_hl || $[45] !== t.jobad_exp_info_text) {
        t4 = <ExperienceReportsIntro headline={t.jobad_exp_hl} text={t.jobad_exp_info_text} />;
        $[44] = t.jobad_exp_hl;
        $[45] = t.jobad_exp_info_text;
        $[46] = t4;
      } else {
        t4 = $[46];
      }
      t1 = "px-6 md:px-10";
      t2 = !(locations?.includes("Essen") && videoId === "m3fh2E9UvPg") && <div className={cn(data?.type === "text" && data.type_2 === "hoch" ? "md:grid-cols-2" : "md:grid-cols-3", "mx-auto mb-8 grid h-full max-w-screen-xl md:gap-8 xl:mb-12 xl:gap-12")}><div className={cn(data?.type === "text" && data.type_2 === "hoch" ? "col-span-1" : "col-span-2", "relative h-full")} data-source="job">{videoId ? <YouTubePlayer thumbnailSrc={`images/jobad/reports/${data?.image_name}.jpg`} videoId={videoId} /> : <CustomImage alt={`${data?.name}, ${data?.job_title}`} className="w-full" height={data?.type_2 === "hoch" ? 800 : 600} src={`images/jobad/reports/${data?.image_name}.jpg`} width={data?.type_2 === "hoch" ? 600 : 800} />}</div><div className={cn(data?.type === "text" && data.type_2 === "hoch" && "lg:w-3/4", "flex h-full flex-col justify-end")}><h3 className="mt-6 font-bold text-4xl text-primary md:mt-0" data-source="job">{data?.headline || <div>{data?.name}, {data?.job_title}</div>}</h3>{data?.name && data?.job_title && data?.headline && <p className="mt-2" data-source="job"><span className="font-bold">{data?.name}</span>,{" "}{data?.job_title}</p>}<p className="mt-5 text-foreground text-lg" data-source="job">{data?.text}</p>{data?.type === "text" && <CustomLink blank={true} className="mt-4 flex items-center border-white font-bold text-lg text-primary leading-5 transition-colors duration-300 hover:border-primary" data-source="job" href={data.link}><ArrowRight className="h-8 pr-1" /><p className="border-inherit border-b-2" data-source="lc">{t.jobad_exp_readMore}</p></CustomLink>}</div></div>;
    }
    $[0] = consentStatus;
    $[1] = job.content.experienceReport;
    $[2] = job.data.idClient;
    $[3] = job.data.locations;
    $[4] = t;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
  } else {
    t1 = $[5];
    t2 = $[6];
    t3 = $[7];
    t4 = $[8];
    t5 = $[9];
    t6 = $[10];
    t7 = $[11];
  }
  if (t7 !== Symbol.for("react.early_return_sentinel")) {
    return t7;
  }
  let t8;
  if ($[47] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Kununu className="size-12 text-primary" />;
    $[47] = t8;
  } else {
    t8 = $[47];
  }
  let t9;
  if ($[48] !== t.jobad_exp_card1_title) {
    t9 = <h3 className="mt-4 mb-5 font-bold text-4xl text-primary" data-source="lc">{t.jobad_exp_card1_title}</h3>;
    $[48] = t.jobad_exp_card1_title;
    $[49] = t9;
  } else {
    t9 = $[49];
  }
  let t10;
  if ($[50] !== t.jobad_exp_card1_body) {
    t10 = <p className="text-foreground text-lg" data-source="lc">{t.jobad_exp_card1_body}</p>;
    $[50] = t.jobad_exp_card1_body;
    $[51] = t10;
  } else {
    t10 = $[51];
  }
  let t11;
  if ($[52] !== consentStatus || $[53] !== t.jobad_exp_kununu_linkTitle) {
    t11 = consentStatus && <CustomLink aria-label={t.jobad_exp_kununu_linkTitle} blank={true} className="block pt-5" href="https://kununu.com/de/eon-digital-technology?rfr=affiliate_widget&utm_content=widget_score_logo_small&utm_medium=affiliate&utm_source=widget" title={t.jobad_exp_kununu_linkTitle}><CustomImage alt="Kununu widget" height={100} src="https://widgets.kununu.com/widget_score_logo_small/profiles/48eb74af-71ae-4b53-85ca-a87685c26905" width={170} /></CustomLink>;
    $[52] = consentStatus;
    $[53] = t.jobad_exp_kununu_linkTitle;
    $[54] = t11;
  } else {
    t11 = $[54];
  }
  let t12;
  if ($[55] !== t10 || $[56] !== t11 || $[57] !== t9) {
    t12 = <div className="bg-card p-8 lg:p-12">{t8}{t9}{t10}{t11}</div>;
    $[55] = t10;
    $[56] = t11;
    $[57] = t9;
    $[58] = t12;
  } else {
    t12 = $[58];
  }
  let t13;
  if ($[59] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <Home className="size-12 text-primary" />;
    $[59] = t13;
  } else {
    t13 = $[59];
  }
  let t14;
  if ($[60] !== t.jobad_exp_card2_title) {
    t14 = <h3 className="mt-4 mb-5 font-bold text-4xl text-primary" data-source="lc">{t.jobad_exp_card2_title}</h3>;
    $[60] = t.jobad_exp_card2_title;
    $[61] = t14;
  } else {
    t14 = $[61];
  }
  let t15;
  if ($[62] !== t.jobad_exp_card2_body) {
    t15 = <p className="text-foreground text-lg" data-source="lc">{t.jobad_exp_card2_body}</p>;
    $[62] = t.jobad_exp_card2_body;
    $[63] = t15;
  } else {
    t15 = $[63];
  }
  let t16;
  if ($[64] !== t14 || $[65] !== t15) {
    t16 = <div className="bg-card p-8 lg:p-12">{t13}{t14}{t15}</div>;
    $[64] = t14;
    $[65] = t15;
    $[66] = t16;
  } else {
    t16 = $[66];
  }
  let t17;
  if ($[67] !== t12 || $[68] !== t16) {
    t17 = <div className="mx-auto grid max-w-screen-xl gap-y-5 md:grid-cols-2 md:gap-8 xl:gap-12">{t12}{t16}</div>;
    $[67] = t12;
    $[68] = t16;
    $[69] = t17;
  } else {
    t17 = $[69];
  }
  let t18;
  if ($[70] !== t1 || $[71] !== t17 || $[72] !== t2) {
    t18 = <div className={t1}>{t2}{t17}</div>;
    $[70] = t1;
    $[71] = t17;
    $[72] = t2;
    $[73] = t18;
  } else {
    t18 = $[73];
  }
  let t19;
  if ($[74] !== t18 || $[75] !== t3 || $[76] !== t4) {
    t19 = <div className={t3}>{t4}{t18}</div>;
    $[74] = t18;
    $[75] = t3;
    $[76] = t4;
    $[77] = t19;
  } else {
    t19 = $[77];
  }
  let t20;
  if ($[78] !== t19 || $[79] !== t5 || $[80] !== t6) {
    t20 = <section className={t5} id={t6}>{t19}</section>;
    $[78] = t19;
    $[79] = t5;
    $[80] = t6;
    $[81] = t20;
  } else {
    t20 = $[81];
  }
  return t20;
}
function _temp(location) {
  return location.city;
}